<template>
  <div class="min-vh">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">SETTING TIME</h1>
      <div>
        <b-dropdown
          v-if="useChannelBusinessHour"
          id="dropdown-filter"
          variant="outline"
          right
          ref="dropdownfilter"
          class="filter-custom mr-2 ml-2"
        >
          <template v-slot:button-content>
            <img
              v-if="filter.imageUrl"
              :src="filter.imageUrl"
              :alt="filter.name"
              height="14"
            /><span class="ml-2 text-left">{{ filter.name }}</span>
          </template>
          <b-dropdown-item
            v-for="(item, index) in platformConfigList.slice(1)"
            v-bind:key="index"
            class="border-bottom pointer p-0"
            @click="onChangePlatformConfig(item)"
          >
            <img :src="item.imageUrl" alt="" height="14" /><span
              class="ml-1 text-left"
              >{{ item.name }}</span
            >
          </b-dropdown-item>
        </b-dropdown>
        <b-button variant="main" @click="onEdit()">
          <div>
            <font-awesome-icon icon="plus-square" />
            <span class="ml-2"> CREATE SETTING TIME</span>
          </div>
        </b-button>
      </div>

      <ModalCreateOrEditTime
        ref="createEditTimeModal"
        :form="form"
        :dateLists="dateLists"
        :platformConfigList="platformConfigList"
        :onSubmit="onSubmit"
        :v="$v"
        :useChannelBusinessHour="useChannelBusinessHour"
        :platformConfigId="filter.platformConfigId"
      />
    </div>
    <div class="mt-3 main-theme bg-white-border p-3">
      <b-table
        responsive
        striped
        hover
        class="table-list"
        :items="details"
        :fields="fields"
        :busy="isBusy"
        show-empty
        :empty-text="$t('noData')"
        :current-page="filter.pageNo"
        :per-page="filter.perPage"
      >
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(platformConfigId)="data">
          <div v-if="data.item.platformConfigId > 0" class="tag-social">
            <img :src="data.item.imageUrl" alt="" />
            <span class="mb-0">{{ data.item.platformConfigName }}</span>
          </div>
          <div v-else>Default</div>
        </template>
        <template v-slot:cell(startTime)="data">
          <span>{{
            `${data.item.startTime.substring(0, 5)}${
              language == "th" ? "น." : ""
            }`
          }}</span>
        </template>
        <template v-slot:cell(endTime)="data">
          <span>{{
            `${data.item.endTime.substring(0, 5)}${
              language == "th" ? "น." : ""
            }`
          }}</span>
        </template>
        <template v-slot:cell(active)="data">
          <span v-if="data.item.active" class="text-success">Active</span>
          <span v-else class="text-danger">Inactive</span>
        </template>
        <template v-slot:cell(id)="data">
          <div class="d-flex justify-content-center">
            <b-link class="text-link" @click="onEdit(data.item)">
              <font-awesome-icon
                icon="pencil-alt"
                class="text-warning"
                title="Edit"
              />
            </b-link>
            <b-link class="text-link ml-3" @click="onDeleteModal(data.item)">
              <font-awesome-icon
                icon="trash-alt"
                class="text-danger"
                title="Delete"
              />
            </b-link>
          </div>
        </template>
      </b-table>
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col
          class="form-inline justify-content-center justify-content-sm-between"
        >
          <div v-if="rows > 0" class="my-auto">
            Showing {{ startPage | numeral("0,0") }} to
            {{ endPage | numeral("0,0") }} of
            {{ rows | numeral("0,0") }} entires
          </div>
          <div v-else class="my-auto">{{ rows || 0 }} entire</div>
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filter.pageNo"
              :total-rows="rows"
              :per-page="filter.perPage"
              class="m-md-0"
              @change="pagination"
              align="center"
            ></b-pagination>
          </div>
        </b-col>
      </b-row>
    </div>
    <ModalAlertConfirm
      :msg="$t('confirmDelete')"
      :text="modalMessage"
      :btnConfirm="$t('delete')"
      colorBtnConfirm="danger"
      :btnCancel="$t('cancel')"
      ref="ModalAlertConfirm"
      @confirm="onDeleteData"
    />
  </div>
</template>

<script>
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalCreateOrEditTime from "./component/ModalCreateOrEditTime.vue";
import moment from "moment";
import { mapGetters } from "vuex";
import { required, minValue, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "SettingTime",
  components: {
    ModalAlertConfirm,
    ModalCreateOrEditTime,
  },
  data: function () {
    return {
      modalMessage: "",
      requestIdDelete: null,
      useChannelBusinessHour: false,
      form: {
        platformConfigId: -1,
        platformConfigName: "",
        imageUrl: "",
        name: "",
        id: 0,
        dayId: 0,
        brandId: this.$route.query.brandID,
        startTime: "",
        endTime: "",
        active: true,
      },
      rows: 0,
      isBusy: false,
      dateLists: [],
      platformConfigList: [
        {
          platformConfigId: -1,
          name: "Please Select",
          nameFull: "Please Select",
        },
      ],
      fields: [
        {
          key: "platformConfigId",
          label: this.$t("channel"),
          class: "w-100px",
        },
        {
          key: "name",
          label: this.$t("businessDay"),
          class: "w-100px",
        },
        {
          key: "startTime",
          label: this.$t("openTime"),
          class: "w-100px",
        },
        {
          key: "endTime",
          label: this.$t("closeTime"),
          class: "w-100px",
        },
        {
          key: "active",
          label: this.$t("status"),
          class: "w-100px",
        },
        {
          key: "id",
          label: "",
          class: "w-action",
        },
      ],
      details: [],
      filter: {
        platformConfigId: -1,
        name: "",
        imageUrl: "",
        pageNo: 1,
        perPage: 10,
      },
      startPage: 1,
      endPage: 10,
      language: this.$store.state.language,
    };
  },
  computed: {
    ...mapGetters({ brandList: "getBrandList" }),
  },
  validations() {
    return {
      form: {
        platformConfigId: {
          required: requiredIf(function (item) {
            return this.useChannelBusinessHour;
          }),
          minValue: minValue(this.useChannelBusinessHour ? 0 : -1),
        },
        name: {
          required,
        },
        dayId: {
          required,
          minValue: minValue(1),
        },
        startTime: {
          required,
        },
        endTime: {
          required,
        },
        active: {
          required,
        },
      },
    };
  },
  created: async function () {
    this.useChannelBusinessHour = this.brandList()[0].useChannelBusinessHour;
    if (this.useChannelBusinessHour) await this.getPlatformConfigList();
    await this.getDateList();
    await this.getSettingTime();
  },
  methods: {
    getSettingTime: async function () {
      this.isBusy = true;
      this.details = [];
      this.rows = 0;
      const url = `${this.$baseUrl}/BusinessHour/Get/platformconfigId/${this.filter.platformConfigId}`;
      await this.axios.get(url).then((data) => {
        if (data.result === 1) {
          this.rows = data.detail.length;

          if (this.rows > 0) {
            let details = data.detail.map((item) => {
              let dataPlatformConfig = this.platformConfigList.find(
                (platformConfig) =>
                  platformConfig.platformConfigId == item.platformConfigId
              );
              let platformConfig = {
                platformConfigId: 0,
                name: "Default",
                imageUrl: "",
              };

              if (dataPlatformConfig) {
                platformConfig = dataPlatformConfig;
              }
              return {
                ...item,
                platformConfigName: platformConfig.name,
                platformConfigId: platformConfig.platformConfigId || 0,
                imageUrl: platformConfig.imageUrl,
              };
            });

            this.details = details;
          }

          this.isBusy = false;
        }
      });
    },
    getDateList: async function () {
      const url = `${this.$baseUrl}/BusinessHour/day`;
      await this.axios.get(url).then((data) => {
        if (data.result === 1) {
          let list = [{ id: 0, name: "Please Select" }];
          this.dateLists = list.concat(data.detail);
        }
      });
    },
    getPlatformConfigList: async function () {
      const url = `${this.$baseUrl}/analytics/get-all-platform-config`;
      await this.axios.get(url).then((data) => {
        if (data.result === 1) {
          let list = [
            {
              platformConfigId: -1,
              name: "Please Select",
              nameFull: "Please Select",
            },
            {
              platformConfigId: 0,
              name: "Default",
              nameFull: "Default",
            },
          ];
          let details = data.detail.map((item) => {
            return {
              ...item,
              nameFull: `${item.name} (${item.platformName})`,
            };
          });
          this.platformConfigList = list.concat(details);
          if (this.useChannelBusinessHour) {
            this.filter.platformConfigId = 0;
            this.filter.name = "Default";
            this.filter.imageUrl = "";
          }
        }
      });
    },
    onEdit(data) {
      this.setForm(data);
      this.$v.$reset();
      this.$refs.createEditTimeModal.show();
    },
    onDeleteModal(data) {
      this.requestIdDelete = data.id;
      this.modalMessage = `${this.$t('confirmDelete2')} ${data.name} ${this.$t('time')} ${data.startTime} - ${data.endTime} ${this.$t('yesOrNo')}`;
      this.$refs.ModalAlertConfirm.show();
    },
    setForm(data) {
      if (data) {
        this.form = { ...data };
      } else {
        this.form = {
          platformConfigId: this.filter.platformConfigId,
          platformConfigName: this.filter.name,
          imageUrl: this.filter.imageUrl,
          name: "",
          id: 0,
          dayId: 0,
          brandId: this.$route.query.brandID,
          startTime: "",
          endTime: "",
          active: true,
        };
      }
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }
      this.form.startTime = moment(this.form.startTime).format("HH:mm:ss");
      this.form.endTime = moment(this.form.endTime).format("HH:mm:ss");
      const saveUrl = `${this.$baseUrl}/BusinessHour/`;
      await this.axios
        .post(saveUrl, this.form)
        .then(async (data) => {
          if (data.result == 1) {
            this.$refs.createEditTimeModal.showModal = false;
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            await this.getSettingTime();
          } else {
            this.$refs.createEditTimeModal.showModal = false;
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        })
        .catch((err) => {
          this.$refs.createEditTimeModal.showModal = false;
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
    async onDeleteData() {
      this.$refs.ModalAlertConfirm.hide();
      const id = this.requestIdDelete;
      const deleteUrl = `${this.$baseUrl}/BusinessHour/${id}`;
      await this.axios.delete(deleteUrl).then(async (data) => {
        if (data.result == 1) {
          this.$store.commit("UPDATE_GLOBAL_ALERT", {
            isShow: true,
            msg: data.message,
          });
          await this.getSettingTime();
        } else {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: data.message,
          });
        }
      });
    },
    async pagination(Page) {
      this.filter.pageNo = Page;
      this.getShowingPage(Page);
    },
    async getShowingPage(page) {
      let result = await this.$getShowingPage(page, this.filter);
      this.startPage = result.startPage;
      this.endPage = result.endPage;
    },
    async onChangePlatformConfig(value) {
      this.filter.platformConfigId = value.platformConfigId;
      this.filter.name = value.name;
      this.filter.imageUrl = value.imageUrl;
      await this.getSettingTime();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .dropdown-menu {
  min-width: 300px !important;
  max-width: 400px !important;
  padding: 10px !important;
  max-height: 50vh !important;
  overflow-y: auto;
  .dropdown-item {
    padding: 0.25rem 0;
  }
}
</style>
